import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 alert-config",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-n20Card', {
    class: `px-0 py-0 theme--${_vm.UiTheme ? 'dark' : 'light'} dt-card-text-01`,
    attrs: {
      "title": `${_vm.formItem.email} (${_vm.formItem.userId})`
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('add');
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-trash-alt"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('delete');
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VRow, {
    staticClass: "pt-6",
    attrs: {
      "align": "top"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    ref: "alert-config-account",
    attrs: {
      "value": _vm.formItem.accountId ? `${_vm.accountName} (${_vm.$i18n_t('Common.id')}: ${_vm.formItem.accountId})` : _vm.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
      "label": _vm.$i18n_t('NiotaClassic.Common.accountFilter'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.accountFieldDisabled,
      "readonly": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('niota-classic-common-account-filter', {
          attrs: {
            "iconOnly": "",
            "n1Accounts": ""
          },
          on: {
            "selected": accounts => {
              _vm.formItem.accountId = accounts.length ? accounts[0].id : undefined;
              _vm.accountName = accounts.length ? accounts[0].name : undefined;
              // toggle state, because the 'disabled' will not update the input otherwise
              _vm.accountFieldDisabled = false;
              _vm.accountFieldDisabled = true;
            },
            "reset-filter": () => {
              _vm.formItem.accountId = undefined;
            }
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.alertMailBridge'),
      "items": _vm.bridges,
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "item-text": "uiTitle",
      "item-value": "id",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.bridgeId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "bridgeId", $$v);
      },
      expression: "formItem.properties.bridgeId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.email.server.email'),
      "color": _vm.color,
      "rules": _vm.senderMailRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "validate-on-blur": "",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.properties.emailFrom,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "emailFrom", $$v);
      },
      expression: "formItem.properties.emailFrom"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.alertForm.recipients'),
      "color": _vm.color,
      "rules": _vm.emailRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "validate-on-blur": "",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.emails,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "emails", $$v);
      },
      expression: "formItem.properties.emails"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.email.templates.subject'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.emailSubject,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "emailSubject", $$v);
      },
      expression: "formItem.properties.emailSubject"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.email.templates.body'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.emailBody,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "emailBody", $$v);
      },
      expression: "formItem.properties.emailBody"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };